module.exports = __webpack_public_path__ + "static/media/login-black.14813185.svg";